import {
  TravelExpenseSuggestedAuditCommentDTO,
  TravelExpenseSuggestedAuditCommentSTO,
} from "../../models/travel-expense-suggested-audit-comment";
import { BaseApiService } from "../base/base-api.service";

export class TravelExpenseSuggestedAuditCommentApiService extends BaseApiService<
  TravelExpenseSuggestedAuditCommentDTO,
  TravelExpenseSuggestedAuditCommentSTO
> {
  constructor() {
    super({
      servicePath: "/TravelExpenseSuggestedAuditComment",
      loadItemsPath: "/GetTravelExpenseSuggestedAuditComment",
      saveItemsPath: "/SaveTravelExpenseSuggestedAuditComment",
    });
  }
}
